import React, { useEffect, useRef, useState } from 'react';
import { Button } from "../Button";
import { CloseButton } from "../CloseButton";
import { Popover } from "../Popover";
import { Typography } from "../Typography";
import styles from "./FilterPicker.module.scss";
import { WideArrowUpward, WideArrowDownward, Close12 } from "../../icons";
import { ChipButton } from "../ChipButton";
export const FilterPicker = props => {
  const {
    children,
    title,
    label,
    removable,
    disableApply,
    headerContent,
    startOpen = false,
    popoverWidth,
    onRemove,
    onClose,
    onApply,
    highlightTrigger
  } = props;
  const testId = props['data-testid'];
  const anchorElRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isHighlighted, setIsHilighted] = useState(highlightTrigger);
  function closePopover(options) {
    setAnchorEl(null);
    setTimeout(() => {
      //wait for animation to finish and only then close
      onClose(options);
    }, 100);
  }
  useEffect(() => {
    if (anchorEl) {
      setIsHilighted(true);
    } else {
      setIsHilighted(highlightTrigger);
    }
  }, [anchorEl, highlightTrigger]);
  useEffect(() => {
    if (startOpen && anchorElRef.current) {
      setAnchorEl(anchorElRef.current);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.chip
  }, /*#__PURE__*/React.createElement(ChipButton, {
    ref: anchorElRef,
    "data-testid": "".concat(testId, "-trigger"),
    suffixIcon: anchorEl ? /*#__PURE__*/React.createElement(WideArrowUpward, null) : /*#__PURE__*/React.createElement(WideArrowDownward, null),
    onClick: e => setAnchorEl(e.currentTarget),
    highlight: isHighlighted
  }, label), removable && /*#__PURE__*/React.createElement("button", {
    className: styles.remove,
    "data-testid": "".concat(testId, "-remove"),
    onClick: onRemove
  }, /*#__PURE__*/React.createElement(Close12, {
    height: 6,
    width: 6
  }))), /*#__PURE__*/React.createElement(Popover, {
    open: !!anchorEl,
    anchorEl: anchorEl,
    onClose: () => closePopover({
      revert: true
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.popover,
    style: {
      width: popoverWidth
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.closeButtonContainer
  }, /*#__PURE__*/React.createElement(CloseButton, {
    "data-testid": "".concat(testId, "-close"),
    size: "small",
    onClick: () => {
      closePopover({
        revert: true
      });
    }
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    skin: "secondary"
  }, title), headerContent), /*#__PURE__*/React.createElement("div", {
    className: styles.filters
  }, children), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "".concat(testId, "-apply"),
    fluid: true,
    disabled: disableApply,
    onClick: () => {
      onApply();
      closePopover({
        revert: false
      });
    }
  }, "Apply")))));
};